<template>
  <div class="color-container">
    <part v-for="part in parts" :part="part"
          :colors="part.color_group.colors"
          :selected_color="part.designs_part.color"
          :key="part.id" v-if="part.is_editable"></part>
    <div class="footer">
      <div class="footer-container">
        <button class="next-button" @click="$router.push({name: 'font'})">次へ</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Part from './Color/Part.vue'
  import axios from 'axios/dist/axios.min'

  export default {
    name: 'color',
    components: {
      Part,
    },
    computed: {
      ...mapState(['cart']),
      parts () {
        return this.cart.parts;
      },
      selectedDesign () {
        return this.cart.design;
      },
    },
    methods: {
      initialize: function () {
        if (!this.selectedDesign) return;
        // デザインを決定した後の処理
        this.$store.commit('setLoading');
        window.axios.get('/designs/' + this.selectedDesign.id + '.json').then(response => {
          this.$store.commit('setCartParts', response.data.design.parts);
          this.$store.commit('resetLoading');
        });
      }
    },
    created (){
      if (this.cart.parts.length === 0) {
        this.initialize();
      }
    },
    deactivated(){
      this.$store.commit('resetLoading');
    },
    watch: {
      selectedDesign: function() {
        if (this.cart.design && this.cart.parts.length === 0){
          this.initialize();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .color-container {
    padding-bottom: 4rem;
  }
  .footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #fff;
    background-color: #151d66;
    z-index: 1001;
    .footer-container {
      padding: 5px;
      height: 36px;
      text-align: center;
      button {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
</style>

